/** Caja del día: arqueo, cuadre y listado global de pagos (recorrido F4). */
import { apiDownload, apiRequest } from "../../lib/api";

export type FormaPago =
  | "Efectivo"
  | "Transferencia"
  | "Tarjeta"
  | "Cheque"
  | "Saldo a Favor";

/** Las que entran al cajón: "Saldo a Favor" no es dinero, es un crédito. */
export const FORMAS_CON_DINERO: FormaPago[] = [
  "Efectivo",
  "Transferencia",
  "Tarjeta",
  "Cheque",
];

export interface PagoEnCaja {
  id: number;
  fecha_pago: string;
  socio_id: number;
  socio_nombre: string;
  socio_rut: string | null;
  monto_pagado: number;
  forma_pago: FormaPago;
  nro_comprobante: string | null;
  estado: "Activo" | "Anulado";
  recibido_por_id: number | null;
  recibido_por_nombre: string | null;
  observaciones: string | null;
}

export interface TotalPorClave {
  clave: string;
  etiqueta: string;
  cantidad: number;
  monto: number;
}

export interface CierreCaja {
  id: number;
  fecha: string;
  estado: "Cerrada" | "Reabierta";
  total_sistema: number;
  total_declarado: number;
  diferencia: number;
  cantidad_pagos: number;
  /** `{ Efectivo: { sistema, declarado } }` — lo que se contó ese día. */
  detalle: Record<string, { sistema: number; declarado: number }> | null;
  observaciones: string | null;
  cerrado_por_id: number | null;
  cerrado_por_nombre: string | null;
  fecha_cierre: string;
  motivo_reapertura: string | null;
  fecha_reapertura: string | null;
}

export interface ArqueoDia {
  fecha: string;
  total_recaudado: number;
  cantidad_pagos: number;
  por_forma: TotalPorClave[];
  por_recaudador: TotalPorClave[];
  anulados_cantidad: number;
  anulados_monto: number;
  aplicaciones_saldo_favor: number;
  pagos: PagoEnCaja[];
  cierre: CierreCaja | null;
}

export function obtenerArqueo(
  fecha: string,
  recibidoPorId?: number | null,
): Promise<ArqueoDia> {
  const params = new URLSearchParams({ fecha });
  if (recibidoPorId != null) params.set("recibido_por_id", String(recibidoPorId));
  return apiRequest<ArqueoDia>(`/api/v1/pagos/caja?${params.toString()}`);
}

export function listarCierresCaja(): Promise<CierreCaja[]> {
  return apiRequest<CierreCaja[]>("/api/v1/pagos/caja/cierres");
}

export function cerrarCaja(payload: {
  fecha: string;
  declarado: Record<string, number>;
  observaciones?: string | null;
}): Promise<CierreCaja> {
  return apiRequest<CierreCaja>("/api/v1/pagos/caja/cerrar", {
    method: "POST",
    body: payload,
  });
}

export function reabrirCaja(cierreId: number, motivo: string): Promise<CierreCaja> {
  return apiRequest<CierreCaja>(`/api/v1/pagos/caja/cierres/${cierreId}/reabrir`, {
    method: "POST",
    body: { motivo },
  });
}

export function descargarCajaCsv(
  fecha: string,
  recibidoPorId?: number | null,
): Promise<void> {
  const params = new URLSearchParams({ fecha });
  if (recibidoPorId != null) params.set("recibido_por_id", String(recibidoPorId));
  return apiDownload(
    `/api/v1/pagos/caja/export.csv?${params.toString()}`,
    `caja_${fecha}.csv`,
  );
}
